import { render, staticRenderFns } from "./ExampleItem-data.vue?vue&type=template&id=19826f10&scoped=true&"
import script from "./ExampleItem-data.vue?vue&type=script&lang=js&"
export * from "./ExampleItem-data.vue?vue&type=script&lang=js&"
import style0 from "./ExampleItem-data.vue?vue&type=style&index=0&id=19826f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19826f10",
  null
  
)

export default component.exports